export default function initializeImageSlider() {
  document.querySelectorAll('.image-slider:has(.image-slider__swiper)').forEach(function (block) {
    new ImageSlider(block);
  });
}

class ImageSlider {
  constructor(block) {
    this.block = block;
    this.init();
  }

  init() {

    import('swiper/bundle').then(({default: Swiper}) => {

      var timer;

      window.addEventListener('resize', () => {
        if (timer) {
          clearTimeout(timer);
        }

        timer = setTimeout(() => this.initSwiper(Swiper), 200);
      });
      this.initSwiper(Swiper);

   });
  }


  initSwiper(Swiper) {

    const slider = this.block.querySelector('.image-slider__swiper');

    const swiper = new Swiper(slider, {
      speed: 1000,
      loop: true,
      parallax: true,
      autoplay: {
        delay: 7000,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
      },

      on: {
        init: (e) => {
          const activeSlide = e.slides[e.activeIndex];
          const item = activeSlide.querySelector('.news_slider__item');
          if (item) {
            setTimeout(() => {
              item.classList.add('news_slider__item--active');
            }, 1000); // не потрібно лапок навколо числа
          }
        },

        slideChange: (e) => {
          const activeIndex = e.activeIndex;

          e.slides.forEach((slide, index) => {
            const item = slide.querySelector('.news_slider__item');

            if (!item) return; // якщо немає — пропускаємо

            if (slide === e.slides[activeIndex]) {
              setTimeout(() => {
                item.classList.add('news_slider__item--active');
              }, 1000);
            } else {
              item.classList.remove('news_slider__item--active');
            }
          });
        },
      }

    });
    // Znajdź przycisk kontrolny
    const controlButton = slider.querySelector('.image-slider__button-play');
    const pauseIcon = controlButton.querySelector('.image-slider__button-icon--pause');
    const startIcon = controlButton.querySelector('.image-slider__button-icon--start');

    controlButton.addEventListener('click', () => {
      if (swiper.autoplay.running) {
        swiper.autoplay.stop();
        controlButton.setAttribute('aria-label', startIcon.title.trim());
        pauseIcon.classList.add('d-none');
        startIcon.classList.remove('d-none');
      } else {
        swiper.autoplay.start();
        controlButton.setAttribute('aria-label', pauseIcon.title.trim());
        startIcon.classList.add('d-none');
        pauseIcon.classList.remove('d-none');
      }
    });

    const controlButtonPrev = slider.querySelector('.image-slider__button-prev');
    controlButtonPrev.addEventListener('click', () => {
        swiper.slidePrev();
    });
    const controlButtonNext = slider.querySelector('.image-slider__button-next');
    controlButtonNext.addEventListener('click', () => {
        swiper.slideNext();
    });

  }
}